<template>
    <div class="box" :class="{'is-open' : open}"><span v-if="item.color" class="box-border" :style="{'background-color' : item.color}"></span>
        <header class="box-header" @click="toggleBox">
            <span class="box-toggle icon-plus_x" v-if="hasContent"></span>
            <h3>{{ item.title }}</h3>
            <p class="box-time" v-if="fullDay">Ganztags</p>

            <p class="box-time" v-else-if="sameDay">{{ item.start | toMiliSeconds | dateFormat( 'H:i' ) }}&nbsp;Uhr
                                                    - {{item.end | toMiliSeconds | dateFormat( 'H:i' ) }}&nbsp;Uhr</p>
            <p class="box-time" v-else>{{ item.start | toMiliSeconds | dateFormat( 'D.M.Y' ) }} - {{ item.end |
                                       toMiliSeconds | dateFormat( 'D.M.Y' ) }}</p>

            <p><span @click.stop="addLike" :class="{'signedUp': isLiked}" v-if="likeEnabled" class="button-participate">
          <span :key="isLiked">
            <template v-if="isLiked">Ich nehme teil</template>
            <template v-else>Ich will teilnehmen</template></span>
        </span></p>
        </header>
        <transition name="slide-down">
            <div class="box-content" v-show="open" ref="content">
                <img class="box-image" v-for="(img,idx) in item.images" :src="img.url" :key="idx" alt="">
                <div v-html="item.bodytext"></div>

                <download-list :files="item.downloads" v-if="item.downloads"></download-list>

            </div>
        </transition>
    </div>
</template>

<script>

    import Downloadlist from "./Downloadlist";
    import { TweenMax } from 'gsap';
    import api, { ApiDefaults } from '@/utils/api_call';
    import store from "@/utils/store";

    export default {
        name: "ToggleBox",
        props: [ 'item' ],
        data() {
            return {
                open: false

            };
        },
        components: {
            'download-list': Downloadlist
        },
        computed: {
            now() {
                return Math.ceil(new Date().getTime() / 1000);
            },
            likeEnabled() {
                return (this.item.start > this.now && this.item.likes_allowed === true);
            },
            hasContent() {
                return (this.item.images.length > 0 || this.item.downloads.length > 0 || this.item.bodytext);
            },
            sameDay() {
                let start = new Date();
                start.setTime(this.item.start * 1000);

                let end = new Date();
                end.setTime(this.item.end * 1000);

                return start.isSame(end, 'day');
            },
            fullDay() {
                return this.item.start === this.item.end;
            },
            isLiked() {
                return this.item.likes.indexOf(store.getters.getProfile.uid) !== -1;
            }

        },
        methods: {
            addLike() {
                if ( !this.likeEnabled ) return;
                let postData = new URLSearchParams();
                postData.append('tx_c3json_jsondataplugin[controller]', 'JsonDataNews');
                postData.append('tx_c3json_jsondataplugin[action]', 'toggleLike');
                postData.append('tx_c3json_jsondataplugin[news]', this.item.uid);
                postData.append('tx_c3json_jsondataplugin[user]', store.getters.getProfile.uid);

                let apiParams = Object.assign({}, ApiDefaults, {
                    params: {id: 17},
                    method: 'post',
                    data: postData
                });
                api(apiParams).then(
                    ( response ) => {
                        if( typeof response.data.newsDetail != 'undefined' ) {
                            this.item.likes = response.data.newsDetail;
                        }
                        else {
                            this.item.likes = response.data;
                        }
                    }
                              )
                              .catch(error => console.log('Error', error));

            },
            toggleBox: function () {
                if( this.hasContent ) this.open = !this.open;
            }
        },
        created() {
            Events.$on('EventsListCloseAll', () => this.open = false);
        }
    };
</script>

<style scoped>
    .box {
        /*background: #42556B;*/
        /*border-radius: 3px;*/
        /*border: 6px solid #42556B;*/
        /*border-left: 3px solid;*/
        /*padding-top: 9px;*/
        /*padding-bottom: 9px;*/
        position: relative;
        margin: 0;
        transition: all .3s linear;
        will-change: margin, border-radius;
    }

    .box-toggle {
        position: absolute;
        right: 20px;
        top: 14px;
        color: #A1AAB3;
        font-size: 24px;
        width: 1em;
        height: 1em;
        line-height: 1em;
        text-align: center;
        transform-origin: center center;
        transition: transform .3s linear, right .3s linear;
    }

    .box-toggle::before {
        margin: 0;
    }

    .box.is-open {
        margin-left: -3px;
        margin-right: -3px;
        margin-top: 10px;
        /*margin-bottom: 10px;*/
        max-width: calc(100% + 6px);
        box-shadow: 0 4px 6px rgba(0, 0, 0, 0.16);
        border-left-width: 6px;
        border-radius: 6px;
    }

    .box.is-open .box-toggle {
        right: 20px;
        transform: rotate(-135deg);
    }

    .box-border {
        position: absolute;
        top: 0;
        left: 0;
        height: 100%;
        width: 3px;
        border-radius: 3px 0 0 3px;
        transition: width .3s linear;
        will-change: width;
    }

    .box.is-open .box-border {
        width: 6px;
        border-radius: 6px 0 0 6px;
    }

    .box-time {
        font-weight: 400;
        line-height: 1;
        font-size: 10px;
        color: rgba(161, 170, 179, 1);
    }

    .box-image {
        border-radius: 3px;
        margin-bottom: 10px;
    }

    .box-header {
        margin-right: 45px;
    }

    .box-header h3 {
        font-size: 14px;
        line-height: 1.2;
        margin: 0;
    }

    .box-time {
        margin-top: 7px;
    }

    .box-content {
        font-size: 12px;
        margin-top: 20px;
        font-weight: 400;
        overflow: auto;
        max-height: 450px;
        scrollbar-width: thin;
        line-height: 1.4;
    }

    .box-content p + p {
        margin-top: 1.4em;
    }

    .slide-down-enter, .slide-down-leave {
        max-height: 0;
    }

    .slide-down-enter-active {
        overflow: hidden;
        animation: toggleBox-slide-down .5s cubic-bezier(.7, 1.1, .7, 1.1) forwards;
    }

    .slide-down-leave-active {
        overflow: hidden;
        animation: toggleBox-slide-down .5s cubic-bezier(.3, -.1, .3, -.1) reverse forwards;
    }

    @keyframes toggleBox-slide-down {
        0% {
            max-height: 0;
            opacity: 0;
        }
        85% {
            max-height: 450px;
            opacity: 0;
        }
        100% {
            max-height: 450px;
            opacity: 1;
        }
    }

    .button-participate {
        display: block;
        position: relative;
        opacity: 1;
        min-width: 20ch;
        background: #E4223C;
        padding: 0 8px;
        border-radius: 3px;
        font-weight: bold;
        height: 32px;
        overflow: hidden;
        transition: all .15s ease-in-out;
        /*margin-left: -8px;*/
    }

    .button-participate.signedUp {
        background: #394452;
        color: #A1AAB3;
    }

    .button-participate[disabled] {

    }

    /*.switch-text-enter-active,
    .switch-text-leave-active {
      display: block;
      !*position: absolute;*!
      !*top: 50%;*!
      !*left: 0;*!
      transition: all .3s ease-in-out;
    }

    .switch-text-enter {
      opacity: 1;
      transform: scaleY(1);
    }

    .switch-text-leave {
      opacity: 0;
      transform: scaleY(0);
    }*/

    .app--light .box-time {
        color: #394452;
    }

    .app--light .button-participate {
        color: #FFF;
    }
</style>



// WEBPACK FOOTER //
// src/components/subparts/ToggleBox.vue